import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SmashFormsModule } from '../smash-forms/smash-forms.module';
import { SmashSignupFormComponent } from './smash-signup-form/smash-signup-form.component';
import { TranslateModule } from '@ngx-translate/core';
import { SharedModule } from '@app/shared/shared.module';
import { SmashStripeModule } from '../smash-stripe/smash-stripe.module';
import { SmashSignupSummaryComponent } from './smash-signup-summary/smash-signup-summary.component';



@NgModule({
  declarations: [
    SmashSignupFormComponent,
    SmashSignupSummaryComponent,
  ],
  imports: [
    CommonModule,
    TranslateModule,
    SmashFormsModule,
    SmashStripeModule,
    SharedModule
  ],
  exports: [
    SmashSignupFormComponent
  ]
})
export class SmashSignupFormModule { }
